<template>
  <div class="v-law-exam-report">
    <law-exam-report />
  </div>
</template>

<script>
import LawExamReport from '@/components/business/law-exam-report'
export default {
  name: 'VLawExamReport',
  components: { LawExamReport }
}
</script>

<style lang="stylus" scoped>
.v-law-exam-report
  height 100%;
  position absolute;
  top:0;
  z-index: 200;
  left 0;
  right 0;
  overflow-y auto
</style>
